export default {
  methods: {
    link (url, refresh = false) {
      const route = { path: url }
      // triggers a route update
      if (refresh) {
        route.query = { r: this.refreshKey() }
      }
      // use replace on same path to avoid pushing to browser history
      if (this.$route.path === route.path) {
        this.$router.replace(route)
      } else {
        this.$router.push(route)
      }
    },
    refreshKey: function () {
      return (Math.random() + 1).toString(36).substring(7)
    }
  }
}
